import moment from 'moment';
import React, { useRef, useState } from 'react';
import { logger } from '../../../../services/loggerService/loggerService';
import { api } from '../../../api';
import { DatePickerWithPrevNext } from '../../../ui/DatePickerWithPrevNext/DatePickerWithPrevNext';
import { PerformanceTabContentProps } from '../ChaptersPerformanceTabContent/ChaptersPerformanceTabContent';
import { PerformanceTabContent } from '../PerformanceTabContent/PerformanceTabContent';
import { FetchParams, PerformanceTabs } from '../performanceUtils';
import { HandlePageChange } from '../types/HandlePageChange';
import { monetizationTopStoriesColumns, monetizationTopStoriesHeaders } from './monetizationTopStoriesColumns';

export function MonetizationTopStoriesPerformanceTabContent(props: PerformanceTabContentProps) {
  const { pageSize } = props;
  const [filterByDate, setFilterByDate] = useState<Date>(new Date());

  const handlePageChangeRef = useRef<HandlePageChange>();
  const totalCountRef = useRef<number>(100);

  const fetchPerformanceData = async (
    params: FetchParams,
    signal: AbortSignal,
  ) => {
    const filterDate = moment(filterByDate).format('YYYY-MM-DD');
    const { limit: limitParam } = params;
    const limit = limitParam ?? totalCountRef.current;
    const fetchParams = { ...params, limit, date: filterDate };

    try {
      const response = await api.get(
        '/v2/analytics/performance/started/topStoriesByDate',
        { params: fetchParams, signal },
      );
      totalCountRef.current = response.data.count;
      return response.data;
    } catch (error) {
      if (!signal.aborted) {
        logger.error('Error fetching monetization top stories performance data', error);
      }
      return [];
    }
  };

  const handleSelect = (date: Date) => {
    setFilterByDate(date);
    handlePageChangeRef.current?.(1);
  };

  return (
    <div>
      <DatePickerWithPrevNext
        filterByDate={filterByDate}
        onSelect={handleSelect}
        maxDate={moment().startOf('day').toDate()}
      />
      <PerformanceTabContent
        tabTitle={PerformanceTabs.MonetizationTopStories}
        csvHeaders={monetizationTopStoriesHeaders}
        columns={monetizationTopStoriesColumns}
        getData={fetchPerformanceData}
        pageSize={pageSize}
        handlePageChangeCallback={(handlePageChange: HandlePageChange) => {
          handlePageChangeRef.current = handlePageChange;
        }}
        emptyComponent={(
          <div className="mt-5 mx-auto w-50 text-center">
            You can view the number of users
            <br />
            who started your games each day here.
            <br />
            Try publishing your first game to view!
          </div>
        )}
      />
    </div>
  );
}
